import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const mobile = '@media (max-width: 768px)'

const flexRow = css`
  display: flex;
`
const flexCol = css`
  ${flexRow};
  flex-direction: column;
`
const flexCenter = css`
  ${flexRow};
  align-items: center;
  justify-content: center;
`

export const Container = styled.section`
  width: 1180px;
  margin: 0 auto;
  padding: 80px 10px 0;
  position: relative;
  ${flexCol};
  ${mobile} {
    width: 100%;
    padding: 40px 15px 0;
  }
`

export const Wrapper = styled.div`
  ${flexCol};
  width: 100%;
`
export const Content = styled.div``

export const Title = styled.h2`
  font-size: 35px;
  font-family: 'Segoe UI', Arial;
  font-weight: 400;
  color: #78be20;
  ${flexRow};
  margin-bottom: 20px;
  span {
    font-weight: 800;
    margin-right: 10px;
  }
  ${mobile} {
    font-size: 26px;
    flex-wrap: wrap;
  }
`
export const RowTextIntro = styled.div`
  margin-bottom: 60px;
  p {
    margin-top: 15px;
    margin-bottom: 20px;
    font-size: 18px;
    line-height: 26px;
    width: 750px;
    position: relative;
    ${mobile} {
      width: 100%;
      font-size: 16px;
    }
  }
  svg {
    position: absolute;
    right: -70px;
    top: 35px;
    ${mobile} {
      display: none;
    }
  }
`

export const Subtitle = styled.h2`
  font-size: 30px;
  font-family: 'Segoe UI', Arial;
  font-weight: 800;
  color: #78be20;
  ${flexRow};
  margin-bottom: 20px;
  ${mobile} {
    font-size: 22px;
  }
`

export const RowScore = styled.div`
  ${flexRow};
  margin-bottom: 50px;
  gap: 20px;
  ${mobile} {
    flex-direction: column;
  }
`

export const ScoreTitle = styled.div`
  ${flexRow};
  border: 2px solid #eeeef0;
  padding: 30px 25px 20px;
  margin: 0;
  font-size: 28px;
  border-radius: 20px;
  font-weight: bold;
  flex-direction: column;
  width: 260px;
  ${mobile} {
    width: 100%;
    font-size: 20px;
  }
`

export const ScoreInfo = styled.div`
  ${flexRow};
  background-color: #f3f3f3;
  padding: 28px 28px 20px;
  margin: 0;
  border-radius: 20px;
  width: 100%;
  flex-direction: column;
  position: relative;
  h3 {
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 15px;
    ${mobile} {
      font-size: 18px;
    }
  }
  p {
    font-size: 19px;
    line-height: 30px;
    ${mobile} {
      font-size: 16px;
    }
  }
`

export const ScoreIcons = styled.div`
  position: absolute;
  top: 22px;
  right: 28px;
  ${flexRow};
  gap: 25px;
  ${mobile} {
    position: static;
    margin-top: 20px;
    justify-content: center;
  }
`

export const RowConditions = styled.div`
  ${flexRow};
  border: 1px solid #eeeef0;
  border-radius: 20px;
  padding: 30px 35px;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
  margin-bottom: 30px;
  ${mobile} {
    flex-direction: column;
    align-items: flex-start;
  }
`

export const ConditionsTitle = styled.div`
  font-size: 22px;
  font-weight: bold;
  width: 300px;
  ${mobile} {
    width: 100%;
  }
`

export const ConditionsObligation = styled.div`
  ${flexCol};
  gap: 10px;
  font-size: 18px;
  line-height: 30px;
  justify-content: center;
  ${mobile} {
    font-size: 16px;
  }
`

export const RowExample = styled.div`
  ${flexRow};
  gap: 30px;
  margin-bottom: 30px;
  ${mobile} {
    flex-direction: column;
  }
`

export const ExampleInfo = styled.div`
  margin-top: 30px;
  h3 {
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 30px;
    ${mobile} {
      font-size: 18px;
    }
  }
  p {
    width: 250px;
    font-size: 18px;
    line-height: 30px;
    ${mobile} {
      width: 100%;
      font-size: 16px;
    }
  }
`

export const ExampleFigure = styled.div`
  background: #78be20;
  border-radius: 50px;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  padding: 20px 40px;
  color: #ffffff;
  line-height: 44px;
  width: 260px;
  white-space: nowrap;
  ${mobile} {
    width: 100%;
    font-size: 18px;
    padding: 15px;
  }
`

export const ExampleInfoRow = styled.div`
  ${flexRow};
  ${mobile} {
    flex-direction: column;
    gap: 15px;
  }
`

export const ExampleExceptions = styled.div`
  border-radius: 20px;
  background: #f9dfdd;
  width: 100%;
  padding: 20px 40px 0;
  h4 {
    color: #da291c;
    font-size: 22px;
    margin-bottom: 20px;
    ${mobile} {
      font-size: 18px;
    }
  }
  ul {
    ${flexRow};
    flex-wrap: wrap;
  }
  li {
    ${flexRow};
    gap: 20px;
    width: 50%;
    margin: 20px 0;
    font-size: 17px;
    align-items: center;
    ${mobile} {
      width: 100%;
      font-size: 16px;
    }
    span {
      width: 80%;
      padding-bottom: 2px;
    }
  }
`

export const DeadlineRow = styled.div`
  ${flexRow};
  align-items: center;
  margin-bottom: 20px;
  h3 {
    font-size: 22px;
    font-weight: bold;
    width: 220px;
    ${mobile} {
      font-size: 18px;
      width: 100%;
      margin-bottom: 10px;
    }
  }
  p {
    font-size: 18px;
    line-height: 30px;
    ${mobile} {
      font-size: 16px;
    }
  }
  ${mobile} {
    flex-direction: column;
    align-items: flex-start;
  }
`

export const TableExpiration = styled.div`
  ${flexCol};
  margin-bottom: 40px;
  h4 {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  p {
    font-size: 16px;
    line-height: 24px;
    margin-top: 10px;
  }
`

export const TableExpirationLabel = styled.div`
  background: #78be20;
  border-radius: 10px;
  color: white;
  text-align: center;
  padding: 4px 8px;
`

export const TableExpirationValuel = styled.div`
  background: #f3f3f3;
  border-radius: 10px;
  text-align: center;
  padding: 4px 8px;
`

export const TableWrapper = styled.div`
  position: relative;
  padding: 0 50px;
  margin: 10px 0;
`

export const Arrow = styled.button`
  position: absolute;
  left: 4px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 5;
  border: 0;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  display: grid;
  place-items: center;
  backdrop-filter: blur(2px);
  span {
    position: relative;
    bottom: 1px;
  }
`

export const ArrowRight = styled(Arrow)(
  () => css`
    left: auto;
    right: 4px;
  `
)

export const FadeLeft = styled.div`
  pointer-events: none;
  position: absolute;
  left: 45px;
  top: 0;
  bottom: 0;
  width: 24px;
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 1),
    rgba(255, 255, 255, 0)
  );
`

export const FadeRight = styled(FadeLeft)(
  () => css`
    left: auto;
    right: 45px;
    transform: scaleX(-1);
  `
)

export const TableExpirationRow = styled.div`
  ${flexRow};
  justify-content: flex-start;
  overflow-x: auto;
  gap: 16px;
  padding-bottom: 10px;
  scroll-behavior: smooth;
  scroll-snap-type: x proximity;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`

export const TableExpirationColumn = styled.div`
  ${flexRow};
  gap: 10px;
  flex-direction: column;
  min-width: 120px;
  flex-shrink: 0;
  /* cada coluna "trava" melhor ao parar */
  scroll-snap-align: start;
`

export const RowExtraScore = styled.div`
  ${flexRow};
  margin-bottom: 20px;
  gap: 20px;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export const ExtraScoreTitle = styled.div`
  ${flexRow};
  border: 2px solid #eeeef0;
  padding: 30px 25px;
  margin: 0;
  font-size: 26px;
  border-radius: 20px;
  font-weight: bold;
  flex-direction: column;
  width: 320px;
  svg {
    margin-top: 25px;
  }
  @media (max-width: 768px) {
    width: 100%;
    font-size: 20px;
  }
`

export const ExtraScoreInfo = styled.div`
  ${flexRow};
  background-color: #f3f3f3;
  padding: 28px 28px 20px;
  margin: 0;
  border-radius: 20px;
  width: 100%;
  flex-direction: column;
  position: relative;
  h3 {
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 10px;
    @media (max-width: 768px) {
      font-size: 18px;
    }
  }
  p {
    font-size: 17px;
    line-height: 26px;
    margin: 5px 0;
    @media (max-width: 768px) {
      font-size: 16px;
    }
  }
`

export const ExtraScoreIcons = styled.div`
  position: absolute;
  top: 22px;
  right: 28px;
  ${flexRow};
  gap: 25px;
  @media (max-width: 768px) {
    position: static;
    margin-top: 20px;
    justify-content: center;
  }
`

export const PointConditions = styled.div`
  ${flexRow};
  margin-top: 15px;
  border: 2px solid #eeeef0;
  border-radius: 20px;
  flex-direction: column;
  padding: 30px 40px;
  margin-bottom: 20px;
  h4 {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;
    @media (max-width: 768px) {
      font-size: 18px;
    }
  }
`

export const PointConditionsRow = styled.div`
  ${flexRow};
  gap: 50px;
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 20px;
  }
`

export const PointConditionsColumn = styled.div`
  ${flexCol};
  span {
    color: #78be20;
    font-size: 20px;
    font-weight: bold;
    @media (max-width: 768px) {
      font-size: 18px;
    }
  }
  p {
    margin-top: 10px;
    font-size: 18px;
    @media (max-width: 768px) {
      font-size: 16px;
    }
  }
`

export const PointRescue = styled.div`
  ${flexRow};
  margin-top: 15px;
  border: 2px solid #eeeef0;
  border-radius: 20px;
  flex-direction: column;
  padding: 30px 40px;
  margin-bottom: 50px;
  h4 {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;
    @media (max-width: 768px) {
      font-size: 18px;
    }
  }
  svg {
    width: 98%;
  }
`

export const PointRescueRow = styled.div`
  ${flexRow};
  gap: 50px;
  margin-top: 10px;
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 20px;
  }
`

export const PointRescueColumn = styled.div`
  ${flexRow};
  gap: 20px;
  align-items: center;
  strong {
    font-size: 20px;
    @media (max-width: 768px) {
      font-size: 18px;
    }
  }
  @media (max-width: 768px) {
    align-items: flex-start;
  }
`

export const CardRow = styled.div`
  ${flexRow};
  gap: 50px;
  margin-bottom: 40px;
  ${mobile} {
    flex-direction: column;
    gap: 30px;
  }
`

export const CardColumn = styled.div`
  ${flexRow};
  gap: 15px;
  width: 50%;
  h3 {
    color: #78be20;
    font-weight: bold;
    font-size: 22px;
    margin-bottom: 10px;
    margin-top: 12px;
    ${mobile} {
      font-size: 20px;
    }
  }
  li {
    margin: 5px 0;
    font-weight: bold;
    font-size: 20px;
    ${flexRow};
    gap: 5px;
    ${mobile} {
      font-size: 18px;
    }
  }
  ${mobile} {
    width: 100%;
    flex-direction: column;
  }
`

export const CardImage = styled.div`
  width: 240px;
  svg {
    width: 100%;
    height: 150px;
  }
  ${mobile} {
    width: 100%;
    svg {
      height: auto;
    }
  }
`

export const LegendRow = styled.div`
  ${flexRow};
  gap: 20px;
  ${mobile} {
    flex-direction: column;
  }
`

export const LegendColumn = styled.div`
  border: 2px solid #eeeef0;
  border-radius: 20px;
  padding: 30px;
  width: 50%;
  h3 {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 15px;
    ${mobile} {
      font-size: 20px;
    }
  }
  p {
    font-size: 18px;
    line-height: 30px;
    ${mobile} {
      font-size: 16px;
    }
  }
  ${mobile} {
    width: 100%;
  }
`

export const BlockRow = styled.div`
  ${flexRow};
  gap: 20px;
  border: 2px solid #eeeef0;
  border-radius: 20px;
  padding: 30px;
  margin-top: 40px;
  flex-direction: column;
  h3 {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 10px;
    ${mobile} {
      font-size: 20px;
    }
  }
`

export const BlockInnerRow = styled.div`
  ${flexRow};
  gap: 30px;
  ${mobile} {
    flex-direction: column;
    gap: 20px;
  }
`

export const BlockInnerColumn = styled.div`
  ${flexCol};
  span {
    font-size: 22px;
    color: #78be20;
    font-weight: bold;
    padding-bottom: 10px;
    ${mobile} {
      font-size: 18px;
    }
  }
  p {
    font-size: 20px;
    line-height: 30px;
    ${mobile} {
      font-size: 16px;
    }
  }
`

export const PointsRedemption = styled.div`
  ${flexRow};
  position: relative;
  justify-content: end;
  margin-top: 30px;
  margin-bottom: 30px;
  ${mobile} {
    justify-content: center;
  }
`

export const PointsRedemptionRow = styled.div`
  width: 840px;
  h4 {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 15px;
    ${mobile} {
      font-size: 16px;
    }
  }
  p {
    font-size: 18px;
    line-height: 30px;
    margin-top: 20px;
    ${mobile} {
      font-size: 16px;
    }
  }
  ${mobile} {
    width: 100%;
    padding: 0 10px;
  }
`

export const PointsRedemptionTitle = styled.h3`
  color: #78be20;
  font-weight: bold;
  font-size: 28px;
  margin-bottom: 15px;
  ${mobile} {
    font-size: 22px;
  }
`

export const PointsRedemptionRescue = styled.div`
  border: 2px solid #eeeef0;
  border-radius: 15px;
  padding: 20px;
  margin-bottom: 15px;
  h4 {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 10px;
    ${mobile} {
      font-size: 18px;
    }
  }
  p {
    font-size: 18px;
    line-height: 30px;
    ${mobile} {
      font-size: 16px;
    }
  }
`

export const PointsRedemptionBg = styled.div`
  position: absolute;
  top: 0%;
  left: 0;
  ${mobile} {
    display: none;
  }
`

export const RescueMoreInfo = styled.div`
  ${flexRow};
  gap: 30px;
  padding-top: 30px;
  ${mobile} {
    flex-direction: column;
    gap: 20px;
  }
`

export const RescueMoreInfoColumn = styled.div`
  ${flexCol};
  width: 50%;
  p {
    font-size: 18px;
    line-height: 30px;
    margin-top: 20px;
    ${mobile} {
      font-size: 16px;
    }
  }
  ${mobile} {
    width: 100%;
  }
`

export const FullInfo = styled.div`
  background: #f2f6bf;
  ${flexCol};
  width: 100%;
  margin-top: 30px;
  margin-bottom: 20px;
  p {
    font-weight: bold;
    font-size: 20px;
    line-height: 30px;
    width: 850px;
    ${mobile} {
      width: 100%;
      font-size: 16px;
      padding: 0 15px;
    }
  }
`

export const CenterInfo = styled.section`
  width: 1180px;
  margin: 0 auto;
  padding: 20px 10px;
  position: relative;
  ${flexCol};
  svg {
    position: absolute;
    right: 0;
    top: -10px;
    ${mobile} {
      display: none;
    }
  }
  ${mobile} {
    width: 100%;
    padding: 20px 15px;
  }
`

export const Center = styled.section`
  width: 1180px;
  margin: 0 auto;
  padding: 20px 10px;
  position: relative;
  ${flexCol};
  ${mobile} {
    width: 100%;
    padding: 20px 15px;
  }
`

export const Cashback = styled.div`
  h2 {
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 20px;
    ${mobile} {
      font-size: 18px;
    }
  }
  margin-bottom: 30px;
`

export const CashbackLine = styled.div`
  ${flexCol};
  border: 2px solid #eeeef0;
  border-radius: 15px;
  padding: 15px 20px;
`

export const CashbackRow = styled.div`
  ${flexRow};
  gap: 20px;
  margin-bottom: 30px;
  ${mobile} {
    flex-direction: column;
  }
`

export const CashbackColumn1 = styled.div`
  background: #78be20;
  border-radius: 15px;
  padding: 30px 20px;
  width: 180px;
  h3 {
    color: white;
    font-weight: bold;
    font-size: 24px;
    ${mobile} {
      font-size: 20px;
    }
  }
  ${mobile} {
    width: 100%;
  }
`

export const CashbackColumn2 = styled.div`
  ${flexCol};
  gap: 20px;
  width: 570px;
  p {
    font-size: 18px;
    line-height: 30px;
    margin-top: 20px;
    ${mobile} {
      font-size: 16px;
    }
  }
  ${mobile} {
    width: 100%;
  }
`

export const CashbackColumn3 = styled.div`
  ${flexCol};
  border: 2px solid #eeeef0;
  border-radius: 15px;
  padding: 15px 20px;
  justify-content: center;
  width: 370px;
  p {
    font-size: 18px;
    line-height: 30px;
    margin-top: 20px;
    ${mobile} {
      font-size: 16px;
    }
  }
  ${mobile} {
    width: 100%;
  }
`

export const HowToUseCashback = styled.div`
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
  ${mobile} {
    font-size: 18px;
  }
`

export const HowToUseCashbackRow = styled.div`
  ${flexRow};
  gap: 20px;
  ${mobile} {
    flex-direction: column;
  }
`

export const HowToUseCashbackColumn1 = styled.div`
  background: #f3f3f3;
  border-radius: 20px;
  padding: 20px 30px;
  width: 330px;
  p {
    margin-top: 15px;
    font-size: 18px;
    line-height: 30px;
    ${mobile} {
      font-size: 16px;
    }
  }
  ${mobile} {
    width: 100%;
  }
`

export const HowToUseCashbackColumn2 = styled.div`
  background: #f3f3f3;
  border-radius: 20px;
  padding: 20px 30px;
  width: 280px;
  ${flexCol};
  justify-content: center;
  p {
    margin-top: 15px;
    font-size: 18px;
    line-height: 30px;
    ${mobile} {
      font-size: 16px;
    }
  }
  ${mobile} {
    width: 100%;
  }
`

export const HowToUseCashbackColumn3 = styled.div`
  background: #f3f3f3;
  border-radius: 20px;
  padding: 20px 30px;
  p {
    margin-top: 15px;
    font-size: 18px;
    line-height: 30px;
    ${mobile} {
      font-size: 16px;
    }
  }
`

export const CashbackList = styled.div`
  border: 2px solid #eeeef0;
  border-radius: 20px;
  padding: 20px 30px;
  margin-top: 20px;
  ${flexCol};
  li {
    padding-top: 10px;
    padding-bottom: 10px;
    ${flexRow};
    gap: 20px;
    align-items: center;
    &:first-child {
      padding-top: 0;
    }
    &:last-child {
      padding-bottom: 0;
    }
    ${mobile} {
      font-size: 16px;
      flex-direction: column;
      align-items: flex-start;
    }
  }
`

export const RowCashbackArc = styled.div`
  ${flexRow};
  gap: 20px;
  margin-bottom: 20px;
  ${mobile} {
    flex-direction: column;
  }
`

export const RowCashbackArcColumnLabel = styled.div`
  border: 2px solid #f3f3f3;
  border-radius: 15px;
  width: 20%;
  padding: 30px 25px;
  ${flexCol};
  svg {
    margin-bottom: 20px;
    ${mobile} {
      width: 40px;
      height: auto;
    }
  }
  h3 {
    font-size: 28px;
    line-height: 40px;
    font-weight: bold;
    ${flexCol};
    strong {
      color: #78be20;
    }
    ${mobile} {
      font-size: 20px;
      line-height: 30px;
    }
  }
  p {
    margin-top: 20px;
    font-size: 20px;
    line-height: 30px;
    ${mobile} {
      font-size: 16px;
    }
  }
  ${mobile} {
    width: 100%;
  }
`

export const RowCashbackArcColumnValue = styled.div`
  border: 2px solid #f3f3f3;
  border-radius: 15px;
  width: 80%;
  ${flexRow};
  ${mobile} {
    width: 100%;
    flex-direction: column;
  }
`

export const RowCashbackArcRow = styled.div`
  ${flexRow};
  ${mobile} {
    flex-direction: column;
  }
`

export const RowCashbackArcReceipt = styled.div`
  padding: 25px;
  width: 56%;
  svg {
    margin-bottom: 10px;
  }
  h3 {
    font-size: 18px;
    font-weight: bold;
    ${mobile} {
      font-size: 16px;
    }
  }
  p {
    font-size: 18px;
    font-weight: 400;
    line-height: 30px;
    ${mobile} {
      font-size: 16px;
    }
  }
  ${mobile} {
    width: 100%;
  }
`

export const RowCashbackArcReceiptRow = styled.div`
  ${flexRow};
  gap: 30px;
  justify-content: space-between;
  ${mobile} {
    flex-direction: column;
    gap: 20px;
  }
`

export const RowCashbackArcReceiptColumn = styled.div`
  width: 50%;
  margin-top: 20px;
  ${mobile} {
    width: 100%;
  }
`

export const RowCashbackArcAlert = styled.div`
  background-color: #fadfdd;
  padding: 25px;
  ${flexCenter};
  gap: 25px;
  width: 44%;
  svg {
    width: 240px;
    ${mobile} {
      width: 100px;
    }
  }
  h3 {
    color: #da291c;
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 5px;
    ${mobile} {
      font-size: 18px;
    }
  }
  p {
    font-size: 20px;
    line-height: 28px;
    font-weight: 400;
    ${mobile} {
      font-size: 16px;
    }
  }
  ${mobile} {
    width: 100%;
    flex-direction: column;
    text-align: center;
  }
`

export const RowCashbackArcAlertRowColumn = styled.div`
  ${flexCol};
`

export const RowCashbackArcMonthPro = styled.div`
  padding: 25px;
  h3 {
    font-size: 21px;
    font-weight: bold;
    margin-bottom: 10px;
    ${mobile} {
      font-size: 18px;
    }
  }
  p {
    font-size: 18px;
    line-height: 30px;
    margin-bottom: 20px;
    ${mobile} {
      font-size: 16px;
    }
  }
  table {
    width: 100%;
    padding: 0;
    border: 1px solid #eeeef0;
    border-collapse: separate;
    border-spacing: 0;
    border-radius: 15px;
    overflow: hidden;
    span {
      color: #1e1e1ee5;
      font-weight: bold;
    }
    ${mobile} {
      display: block;
      overflow-x: auto;
      white-space: nowrap;
    }
  }
  td {
    border: 1px solid #eeeef0;
    padding: 15px 25px;
    font-size: 18px;
    ${mobile} {
      font-size: 16px;
      padding: 10px 15px;
    }
  }
  thead {
    background: #78be20;
    td {
      gap: 10px;
    }
  }
`

export const RowCashbackArcMonthProHead = styled.div`
  ${flexRow};
  gap: 10px;
  color: white;
  font-size: 21px;
  font-weight: bold;
  ${mobile} {
    font-size: 18px;
  }
`

export const CashbackDetailsRow = styled.div`
  ${flexRow};
  gap: 20px;
  ${mobile} {
    flex-direction: column;
  }
`

export const CashbackDetailsColumn = styled.div`
  border: 2px solid #f3f3f3;
  border-radius: 15px;
  padding: 20px;
  ${flexCol};
  justify-content: center;
  width: 50%;
  h3 {
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 25px;
  }
  p {
    font-size: 19px;
    line-height: 28px;
  }
  li {
    ${flexRow};
    align-items: center;
    gap: 20px;
    font-size: 18px;
    margin-bottom: 20px;
  }
  span {
    width: 90%;
  }
  ${mobile} {
    width: 100%;
  }
`

export const CashbackProExceptions = styled.div`
  margin-top: 30px;
  h3 {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;
  }
  ul {
    ${flexRow};
    margin-bottom: 30px;
    justify-content: space-between;
    ${mobile} {
      flex-direction: column;
      gap: 15px;
    }
  }
  li {
    ${flexCol};
    font-weight: bold;
    gap: 15px;
    font-size: 18px;
  }
`

export const CashbackProducts = styled.div`
  border: 2px solid #f3f3f3;
  border-radius: 15px;
  padding: 20px 30px;
  h2 {
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 20px;
  }
  ul {
    ${flexRow};
    justify-content: space-between;
    gap: 60px;
    ${mobile} {
      flex-direction: column;
      gap: 15px;
    }
  }
  li {
    font-size: 18px;
    line-height: 28px;
  }
`

export const FooterBenefits = styled.div`
  ${flexRow};
  gap: 20px;
  margin-top: 130px;
  position: relative;
  ${mobile} {
    flex-direction: column;
  }
`

export const FooterBenefitsBgTop = styled.div`
  position: absolute;
  top: -90px;
  left: -70px;
  ${mobile} {
    display: none;
  }
`

export const FooterBenefitsBgBottom = styled.div`
  position: absolute;
  bottom: -90px;
  right: -75px;
  ${mobile} {
    display: none;
  }
`

const FooterBenefitsColumn = styled.div`
  border: 2px solid #f3f3f3;
  border-radius: 15px;
  padding: 30px;
  ${flexCol};
  justify-content: center;
  position: relative;
  z-index: 1;
  background-color: white;
  h3 {
    color: #78be20;
    font-size: 26px;
    font-weight: bold;
    margin-bottom: 20px;
  }
  li {
    ${flexRow};
    align-items: center;
    gap: 20px;
    font-size: 18px;
    line-height: 30px;
    margin-bottom: 20px;
  }
  span {
    width: 90%;
  }
  p {
    font-size: 19px;
    line-height: 30px;
  }
  ${mobile} {
    width: 100%;
  }
`

export const FooterBenefitsColumn1 = styled(FooterBenefitsColumn)(
  () => css`
    width: 55%;
    ${mobile} {
      width: 100%;
    }
  `
)

export const FooterBenefitsColumn2 = styled(FooterBenefitsColumn)(
  () => css`
    width: 45%;
    ${mobile} {
      width: 100%;
    }
  `
)
